import {gsap} from "gsap";

let projectCarouselsWrapper = null; // Liste des éléments .project-carousel
const tweening_class = "tweening";
const intervals = [];
const delay_auto_interval = 5000;

/**
 * Return carousel warppers and store the nodelist in projectCarouselsWrapper
 * @returns {Element}
 */
const get_carousel_wrappers_el = (container) => container.querySelectorAll('.project-carousel');

/**
 * Initialisation des carousels des pages project single
 */
const carousels_initialize = () => {
    projectCarouselsWrapper.forEach((el) => {
        const $all_li = el.querySelectorAll('ul li');

        $all_li.forEach((li, index) => {
            const pcent = index * 100;
            li.style.left = `${pcent}\%`;
        })
        if($all_li.length > 1){
            // Click carousel = new slide
            el.addEventListener('click', click_carousel);

            //
            const id = get_wrapper_id(el);
            intervals[id] = setInterval(intervalHandler, delay_auto_interval, el);
            el.addEventListener('mouseenter', () => enter_carousel(id));
            el.addEventListener('mouseleave', () => leave_carousel(id, el));
        }
    })
}

const intervalHandler = (wrapper) => {

    var evt = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
    });
    wrapper.dispatchEvent(evt);

};
const enter_carousel = (id) => clearInterval(intervals[id]);
const leave_carousel = (id, wrapper) => intervals[id] = setInterval(intervalHandler, delay_auto_interval, wrapper);

const get_wrapper_id = (el) => el.id.substring(17, el.id.length);
/**
 * Animation au click sur le carrousel
 * @param e
 */
const click_carousel = (e) => {
    const $carousel_wrapper = e.currentTarget,
        $all_li = $carousel_wrapper.querySelectorAll('ul li'),
        posResetCurrent = ($all_li.length - 1) * 100;
    if ($carousel_wrapper.classList.contains(tweening_class)) {
        return;
    }
    $carousel_wrapper.classList.add(tweening_class);
    let $current_li = false,
        $other_li = [];

    $all_li.forEach((li, index) => {
        const pcent_li = parseInt(li.style.left, 10);
        if (pcent_li === 0) {
            $current_li = li;
        } else {
            $other_li.push(li)
        }
    })
    gsap.set($other_li, {zIndex: 20});
    gsap.set($current_li, {zIndex: 10});

    gsap.to($other_li, {
        duration: .6,
        left: '-=100%',
        ease: "power1.out",
        onCompleteParams: [$current_li, $carousel_wrapper, posResetCurrent],
        onComplete: (li, wrapper, pos) => onCompleteCarouselTween(li, wrapper, pos)
    });
}

/**
 * Handler déclenché à la fin du tween :
 *  - Repositionne le current li (l'image qui vient d'être recouverte) à la fin de la frise d'image
 *  - Enlève la class tweening sur le $carousel_wrapper
 * @param $current_li
 * @param $carousel_wrapper
 * @param posResetCurrent
 */
const onCompleteCarouselTween = ($current_li, $carousel_wrapper, posResetCurrent) => {
    gsap.set($current_li, {left: `${posResetCurrent}\%`,})
    $carousel_wrapper.classList.remove(tweening_class);
}

/**
 * Initialisation de la page de projet single
 * @param container
 */
const project_single_init = (container) => {
    projectCarouselsWrapper = get_carousel_wrappers_el(container);
    if (projectCarouselsWrapper.length > 0) {
        carousels_initialize();
    }
}

/**
 * Desinitialization of project list
 */
const project_single_desinit = () => {
    if (projectCarouselsWrapper) {
        projectCarouselsWrapper.forEach((el) => {
            const $all_li = el.querySelectorAll('ul li');
            if($all_li.length > 1){
                // console.log("on enlève le click");
                el.removeEventListener('click', click_carousel);

                const id = get_wrapper_id(el);
                // console.log("on enlève le mouseenter");
                el.removeEventListener('mouseenter', () => enter_carousel(id));

                // console.log("on enlève le mouseleave");
                el.removeEventListener('mouseleave', () => leave_carousel(id, el));

                clearInterval(intervals[id]);
            }
        })
    }


}
export {project_single_init, project_single_desinit};
